import ApiClient from "../api/apiClient";

const REPORT = "/reports"
const GENERATEEXCELSHEET = "/generate-excel"

const getReportDetails = ({
    report_type,
    start_date,
    end_date,
    trend_year,
    technology_field,
    current_working_sector,
    full_name,
    registered_from,
    registered_to,
    identity_number,
    filter_status,
    board_approval_from,
    board_approval_to,
    certificate_type
}) => {
    const baseUrl = `${REPORT}?`;
    let queryParams = "";
    queryParams += `report_type=${report_type}`;
    if (start_date) queryParams += `&start_date=${start_date}`;
    if (end_date) queryParams += `&end_date=${end_date}`;
    if (trend_year) queryParams += `&trend_year=${trend_year}`;
    if (technology_field) queryParams += `&technology_field=${technology_field}`;
    if (current_working_sector) queryParams += `&current_working_sector=${current_working_sector}`;
    if (full_name) queryParams += `&full_name=${full_name}`;
    if (filter_status) queryParams += `&filter_status=${filter_status}`;
    if (registered_from) queryParams += `&registered_from=${registered_from}`;
    if (registered_to) queryParams += `&registered_to=${registered_to}`;
    if (board_approval_from) queryParams += `&board_approval_from=${board_approval_from}`;
    if (board_approval_to) queryParams += `&board_approval_to=${board_approval_to}`;
    if (identity_number) queryParams += `&identity_number=${identity_number}`;
    if (certificate_type) queryParams += `&certificate_type=${certificate_type}`;
    const url = baseUrl + queryParams;
    return ApiClient.get(url);
}

const generateExcelSheet = ({ report_type,
    start_date,
    end_date,
    trend_year,
    technology_field,
    current_working_sector,
    full_name,
    registered_from,
    registered_to,
    payment_from,
    payment_to,
    identity_number,
    filter_status,
    board_approval_from,
    board_approval_to,
    certificate_type }) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const baseUrl = `${GENERATEEXCELSHEET}?`;
    let queryParams = "";
    queryParams += `report_type=${report_type}`;
    if (start_date) queryParams += `&start_date=${start_date}`;
    if (end_date) queryParams += `&end_date=${end_date}`;
    if (trend_year) queryParams += `&trend_year=${trend_year}`;
    if (technology_field) queryParams += `&technology_field=${technology_field}`;
    if (current_working_sector) queryParams += `&current_working_sector=${current_working_sector}`;
    if (full_name) queryParams += `&full_name=${full_name}`;
    if (filter_status) queryParams += `&filter_status=${filter_status}`;
    if (registered_from) queryParams += `&registered_from=${registered_from}`;
    if (registered_to) queryParams += `&registered_to=${registered_to}`;
    if (payment_from) queryParams += `&payment_from=${payment_from}`;
    if (payment_to) queryParams += `&payment_to=${payment_to}`;
    if (board_approval_from) queryParams += `&board_approval_from=${board_approval_from}`;
    if (board_approval_to) queryParams += `&board_approval_to=${board_approval_to}`;
    if (identity_number) queryParams += `&identity_number=${identity_number}`;
    if (certificate_type) queryParams += `&certificate_type=${certificate_type}`;
    const url = baseUrl + queryParams;
    return ApiClient.get(url, { headers: { 'timeZone': timeZone } });
};
export const reportService = {
    getReportDetails,
    generateExcelSheet
};